import { render } from "./TariffMiniView.vue?vue&type=template&id=f395c910&scoped=true"
import script from "./TariffMiniView.vue?vue&type=script&lang=js"
export * from "./TariffMiniView.vue?vue&type=script&lang=js"

import "./TariffMiniView.vue?vue&type=style&index=0&id=f395c910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f395c910"]])

export default __exports__